import { IContact, UNIQUE_ROLES } from 'clickNgo/entities/contact'

export function sortContactListByHPRoles(contactA: IContact, contactB: IContact) {
  const hasIntersection = (roles: string[]) => roles.some((role) => UNIQUE_ROLES.includes(role))

  const aHasPriority = hasIntersection(contactA.hpRoles)
  const bHasPriority = hasIntersection(contactB.hpRoles)

  if (aHasPriority && !bHasPriority) return -1
  if (!aHasPriority && bHasPriority) return 1

  if (contactA.hpRoles.length > 0 && contactB.hpRoles.length === 0) return -1
  if (contactA.hpRoles.length === 0 && contactB.hpRoles.length > 0) return 1

  return 0
}
